import React from "react";

import { LOGIN_TOUR } from "App/Routes";
import TopbarMenu from "components/Topbar/TopbarMenu/TopbarMenu";

import { ENABLE_TOUR } from "config";
import localize from "lang/localize";

class CustomTopbarMenu extends TopbarMenu {
  /* Custom: different text string */
  renderAboutTourItem() {
    if (this.props.state !== "login-tour" && ENABLE_TOUR) {
      return (
        <a
          className="menu-item link"
          onClick={e => {
            this.props.handleHideMenu();
            this.props.handleOpenTourModal(e);
          }}
          href={
            this.props.projectId
              ? LOGIN_TOUR.format(this.props.projectId)
              : LOGIN_TOUR
          }
        >
          <i className="fas fa-info-circle" />
          <span>{localize("topbar_menu_tour_item", this.props.language)}</span>
        </a>
      );
    } else {
      return null;
    }
  }
}

export default CustomTopbarMenu;
